module.exports = __webpack_public_path__ + "static/media/thermohug-1.aae4bb1b.jpg";